import React from "react";
import { Reveal } from "../lib/anim";
import { FAQ } from "../data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 lg:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-4">
        <Reveal><p className="eyebrow mb-6">FAQ</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0]">
            Questions <span className="italic gold-text">fréquentes</span>.
          </h2>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-2xl lg:text-3xl text-[#F5F5F0] hover:text-[#D4AF37] hover:no-underline py-7"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A1A1AA] text-base lg:text-lg leading-relaxed pb-7 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
